import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "width", "height"];
// src/arrow.tsx
import * as React from "react";
import { Primitive } from "@radix-ui/react-primitive";
import { jsx } from "react/jsx-runtime";
var NAME = "Arrow";
var Arrow = React.forwardRef(function (props, forwardedRef) {
  var children = props.children,
      _props$width = props.width,
      width = _props$width === void 0 ? 10 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 5 : _props$height,
      arrowProps = _objectWithoutProperties(props, _excluded);

  return /* @__PURE__ */jsx(Primitive.svg, _objectSpread(_objectSpread({}, arrowProps), {}, {
    ref: forwardedRef,
    width: width,
    height: height,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none",
    children: props.asChild ? children : /* @__PURE__ */jsx("polygon", {
      points: "0,0 30,0 15,10"
    })
  }));
});
Arrow.displayName = NAME;
var Root = Arrow;
export { Arrow, Root };